import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import SectionHeading from '../home/SectionHeading';
import { useInView, reveal } from '../home/motion';
import { useT } from '../../i18n/LanguageContext';

const MAILTO = 'mailto:info@fluel.it?subject=Carte%20personalizzate%20Sinergie%20Generative';

function getSteps(t) {
  return [
    { n: '01', text: t('platform.customCards.step1Text') },
    { n: '02', text: t('platform.customCards.step2Text') },
    { n: '03', text: t('platform.customCards.step3Text') },
  ];
}

export default function PlatformCustomCards() {
  const theme = useTheme();
  const t = useT();
  const { ref, visible } = useInView();
  const STEPS = getSteps(t);

  return (
    <Box sx={{ bgcolor: theme.home.paperDeep, py: theme.home.sectionPy }}>
      <Box sx={{ maxWidth: theme.home.maxWidth, mx: 'auto', px: { xs: 3, md: 5 } }}>
        <SectionHeading
          eyebrow={t('platform.customCards.eyebrow')}
          accent={theme.home.coralText}
          title={t('platform.customCards.title')}
          lede={t('platform.customCards.lede')}
        />

        <Box
          ref={ref}
          sx={{
            mt: { xs: 4, md: 6 }, display: 'grid', gap: 3,
            gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
          }}
        >
          {STEPS.map((s, i) => (
            <Box key={s.n} sx={{ ...reveal(visible, 0.08 * i) }}>
              <Typography sx={{
                fontFamily: theme.home.display, fontWeight: 900, fontSize: '2.2rem',
                color: theme.home.paperDeep, WebkitTextStroke: `1.5px ${theme.home.coralText}`, lineHeight: 1,
              }}>
                {s.n}
              </Typography>
              <Typography sx={{ mt: 1, color: theme.home.inkMuted, lineHeight: 1.65, fontSize: '1.05rem' }}>
                {s.text}
              </Typography>
            </Box>
          ))}
        </Box>

        <Button
          variant="contained" size="large" endIcon={<ArrowForwardIcon />}
          href={MAILTO}
          sx={{ mt: { xs: 5, md: 7 }, px: 3.5, py: 1.4, borderRadius: 999, bgcolor: theme.home.ink,
            '&:hover': { bgcolor: theme.home.inkHover }, boxShadow: theme.home.cardShadow }}
        >
          {t('platform.customCards.cta')}
        </Button>
      </Box>
    </Box>
  );
}
